import { render, staticRenderFns } from "./ManageQuesPage.vue?vue&type=template&id=913232b2&scoped=true&"
import script from "./ManageQuesPage.vue?vue&type=script&lang=js&"
export * from "./ManageQuesPage.vue?vue&type=script&lang=js&"
import style0 from "./ManageQuesPage.vue?vue&type=style&index=0&id=913232b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913232b2",
  null
  
)

export default component.exports